const line = (time, ding) =>
    <div key={ding.startTimeMs} className={"line "+(time > ding.startTimeMs ? (time > ding.endTimeMs?"past":"now") : "future")}>{ding.words}</div>
export function SongText(props) {
    const time=props.info.progress_ms+1500
    return (
        <div style={{ width: "50%"}}>{props.text.lyrics.lines.map(e=>line(time,e))}</div>
    )
}

